// extracted by mini-css-extract-plugin
export default {"container":"tenantStatusTransitionActionsList_container__3EtCi"};